import React from 'react'
import styled from 'styled-components'
import { FormControls } from '@/components/ui/form/FormControls'
import { PrimaryButton } from '@/components/ui/button/PrimaryButton'
import { DefaultButton } from '@/components/ui/button/DefaultButton'
import { getPropValue, Place } from '@/components/Elements/ElementsListItem'
import { translate } from '@/i18n'
import { useSettingsSelector } from '@/utils/settings/use-settings-selector'

const MobileElementsItem = ({ name, item, handleNavigate, openSeat }) => {
  const objectListCols = useSettingsSelector(
    ({ objectListCols }) => objectListCols,
    [],
  )

  return (
    <ItemWrapper>
      <Name>{name}</Name>
      <PropsWrapper>
        <Property>
          <PropName>{translate('type')}</PropName>
          <PropValue>{item.type_name}</PropValue>
        </Property>
        <Property>
          <PropName>{translate('position')}</PropName>
          <PropValue>
            <Place item={item} />
          </PropValue>
        </Property>

        {objectListCols.map(col => (
          <Property>
            <PropName>{col.name}</PropName>
            <PropValue>{getPropValue(item, col)}</PropValue>
          </Property>
        ))}
      </PropsWrapper>
      <FormControls>
        <PrimaryButton onClick={handleNavigate}>
          {translate('show-on-map')}
        </PrimaryButton>
        <DefaultButton onClick={openSeat}>{translate('more')}</DefaultButton>
      </FormControls>
    </ItemWrapper>
  )
}

export default MobileElementsItem

const ItemWrapper = styled.div`
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  padding: 15px 10px;
  color: #000;

  &:not(:last-child) {
    margin-bottom: 12px;
  }
`

const PropsWrapper = styled.div`
  margin: 6px 0 12px 0;
`

const PropName = styled.div`
  max-width: 140px;
  width: 100%;
`
const PropValue = styled.div`
  width: 100%;
  font-weight: 700;
`

const Property = styled.div`
  display: flex;
  &:not(:last-child) {
    margin-bottom: 6px;
  }
`

const Name = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  color: #000000;
`
